import { render, staticRenderFns } from "./S57.vue?vue&type=template&id=47127f1f&scoped=true"
import script from "./S57.vue?vue&type=script&lang=js"
export * from "./S57.vue?vue&type=script&lang=js"
import style0 from "./S57.vue?vue&type=style&index=0&id=47127f1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47127f1f",
  null
  
)

export default component.exports